import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import {
  Page,
  Header,
  HeaderImage,
  Section,
  Grid,
  Item,
  LightboxOverlay,
  LightboxBody,
  LightboxImage,
  LightboxCaption,
  LightboxClose,
} from './GalleryStyles';

const Gallery = () => {
  const [pageData, setPageData] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      api.gallery.getPage().catch(() => null),
      api.gallery.list()
    ]).then(([pg, list]) => {
      if (!mounted) return;
      setPageData(pg);
      setItems(Array.isArray(list) ? list : []);
    }).catch(err => setError(err.message))
      .finally(() => setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;

  return (
    <Page>
      <Header>
        <h1>Gallery</h1>
        <p>{pageData?.description || 'Browse our recent images and media.'}</p>
      </Header>
      {pageData?.headerImage ? (
        <HeaderImage>
          <LazyImage src={pageData.headerImage} alt="Gallery header" />
        </HeaderImage>
      ) : null}
      <Section>
        <Grid>
          {items.map(it => (
            <Item
              key={it._id}
              onClick={() => setSelected(it)}
            >
              {it.image ? (
                <LazyImage
                  src={it.image}
                  alt={it.caption || 'Gallery image'}
                />
              ) : null}
              <div>
                <h4>{it.caption || '—'}</h4>
                <p>{it.category || ''}</p>
              </div>
            </Item>
          ))}
        </Grid>
      </Section>

      {selected && (
        <LightboxOverlay onClick={() => setSelected(null)}>
          <LightboxBody onClick={(e) => e.stopPropagation()}>
            <LightboxClose type="button" onClick={() => setSelected(null)}>
              Close
            </LightboxClose>
            <LightboxImage
              src={selected.image}
              alt={selected.caption || 'Gallery image'}
            />
            {(selected.caption || selected.category) && (
              <LightboxCaption>
                {selected.caption && <h4>{selected.caption}</h4>}
                {selected.category && <p>{selected.category}</p>}
              </LightboxCaption>
            )}
          </LightboxBody>
        </LightboxOverlay>
      )}
    </Page>
  );
};

export default Gallery;
